import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Sla, SlaTemplate } from '@data/models/sla-period.model';
import { SlaPeriodService } from '@data/services/sla-period.service';
import { Observable, Subject, switchMap, tap } from 'rxjs';

interface LoadSlaDialogData {
    loadSlas: (slas: Sla[]) => void;
}

@Component({
    selector: 'syn-project-wizard-sla-load-template',
    templateUrl: 'project-wizard-sla-load-template.component.html',
    styleUrls: ['project-wizard-sla-load-template.component.scss']
})
export class ProjectWizardSlaLoadTemplateComponent implements OnInit {

    public slas: Sla[] | null = null;
    public slaPicker$: Observable<SlaTemplate[]>;
    public slaPickerContentLoader = new Subject<{ term: string; strict: boolean }>();

    public loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: LoadSlaDialogData,
        private readonly matDialogRef: MatDialogRef<ProjectWizardSlaLoadTemplateComponent>,
        private readonly slaPeriodService: SlaPeriodService
    ) {}

    public ngOnInit() {
        this.slaPicker$ = this.slaPickerContentLoader.pipe(
            switchMap((search) => {
                const safeTerm = search.term.replace(/"/g, '');
                const filter = search.strict ? `name:~"${safeTerm}"` : safeTerm;
                this.loading = true;
                return this.slaPeriodService.listSlaTemplates({ filter: filter, limit: 20 }).pipe(
                    tap(() => this.loading = false)
                );
            }),
        );
    }

    public load(): void {
        this.data.loadSlas(this.slas);
    }

    public cancel(): void {
        this.matDialogRef.close(null);
    }
}
